<template>
    <MiniModalCustom :is-open="state.isDeleting">
        <div
            v-if="state.isDeleting"
            class="flex flex-col items-center justify-center pt-8 pb-4"
        >
            <LoadingCircle></LoadingCircle>
            <div class="mt-3 text-[16px] text-bold">Deleting team...</div>
        </div>
    </MiniModalCustom>
    <button
        @click="state.isDeleteModalOpen = true"
        class="
            w-full
            py-1
            pl-4
            pr-8
            flex flex-row
            items-center
            text-left
            gap-2
            cursor-pointer
            hover:bg-gray-100
            rounded-lg
            text-red-500
        "
        type="button"
    >
        <ion-icon name="trash-outline"></ion-icon>
        <div class="flex-grow-1 flex-shrink-0 font-slab">Delete</div>
    </button>
    <ModalCustom
        title="Delete Team"
        :is-open="state.isDeleteModalOpen"
        z-index="1001"
    >
        <form method="post">
            <div
                class="
                    bg-red-100
                    text-red-500
                    py-4
                    px-6
                    rounded-lg
                    text-sm
                    max-w-screen-md
                "
            >
                Deleting a team is permanent and cannot be undone. All data
                associated with the team including the meeting rooms, playbooks,
                plays, forum contents, and other data will be deleted.
            </div>
            <div class="my-4 flex items-center gap-2">
                <input
                    type="checkbox"
                    name="confirm"
                    id="confirm_delete"
                    v-model="state.confirm"
                    required
                />
                <label for="confirm_delete" class="text-sm">
                    I understand the consequences, and I want to delete this
                    team.
                </label>
            </div>
            <input type="hidden" name="team_id" :value="props.teamId" />
            <div class="text-right">
                <button
                    class="bg-gray-200 rounded-md py-2 px-3 mr-4"
                    type="button"
                    @click="state.isDeleteModalOpen = false"
                >
                    <div class="flex-grow-1 flex-shrink-0">Cancel</div>
                </button>
                <button
                    v-if="state.confirm"
                    class="
                        bg-red-500
                        text-white
                        rounded-md
                        py-2
                        px-3
                        invalid:opacity-50
                    "
                    @click="handleDelete"
                    type="button"
                >
                    <div class="flex-grow-1 flex-shrink-0">Delete</div>
                </button>

                <button
                    v-else
                    class="
                        bg-gray-500
                        text-white
                        rounded-md
                        py-2
                        px-3
                        invalid:opacity-50
                    "
                    type="button"
                >
                    <div class="flex-grow-1 flex-shrink-0">Delete</div>
                </button>
            </div>
        </form>
    </ModalCustom>
</template>

<script setup>
import { defineProps, reactive } from "vue";

const props = defineProps(["teamId"]);
const state = reactive({
    confirm: false,
    isDeleting: false,
    isDeleteModalOpen: false,
});

const handleDelete = async () => {
    state.isDeleting = true;
    state.isDeleteModalOpen = false;
    try {
        await axios.post("/teams/delete", {
            team_id: props.teamId,
        });
        window.location.reload();
    } catch (e) {
        console.error(e);
    }
    state.isDeleting = false;
};
</script>
